import {
  GET_ALL_INVOICES,
  GET_INVOICES_WITH_ID,
  UPDATE_INVOICES,
  CREATE_INVOICES,
  GET_INVOICES_LOGS,
  REQUEST_TO_PAY
} from './constants';
// import { Payload, cancelPayload } from './interfaces';

export function getInvoicesAction(payload: Object) {
  return {
    type: GET_ALL_INVOICES,
    payload,
  };
}

export function getInvoiceWithIdAction(payload: Object) {
  return {
    type: GET_INVOICES_WITH_ID,
    payload,
  };
}

export function updateInvoiceActions(payload: { id: number }) {
  return {
    type: UPDATE_INVOICES,
    payload,
  };
}

export function createInvoiceActions(payload: Payload) {
  return {
    type: CREATE_INVOICES,
    payload,
  };
}
export function requestToPayActions(payload: Payload) {
  return {
    type: REQUEST_TO_PAY,
    payload,
  };
}

export function getInvoicesLogs(payload: cancelPayload) {
  return {
    type: GET_INVOICES_LOGS,
    payload,
  };
}

